import { handleActions } from 'redux-actions';
import StatsSection, {
  StatsTimePeriod,
  MySubmissionsSortBy,
} from '../../types/statsSection';
import {
  setStats,
  setTimePeriod,
  setMySubmissionsSortBy,
  setMySubmissionsIsLoading,
  setMySubmissionsStats,
} from '../actions/statsSection';

const defaultState: StatsSection = {
  timePeriod: StatsTimePeriod.Week,
  mySubmissionsSortBy: MySubmissionsSortBy.PublishDate,
  mySubmissionsIsLoading: false,
  stats: {},
};

export default handleActions<StatsSection, any>(
  {
    [setStats.toString()]: (state, action: ReturnType<typeof setStats>) => ({
      ...state,
      stats: action.payload || {},
    }),
    [setMySubmissionsStats.toString()]: (
      state,
      action: ReturnType<typeof setMySubmissionsStats>
    ) => ({
      ...state,
      stats: {
        ...state.stats,
        myContent: action.payload,
      },
    }),
    [setTimePeriod.toString()]: (
      state,
      action: ReturnType<typeof setTimePeriod>
    ) => ({
      ...state,
      timePeriod: action.payload,
    }),
    [setMySubmissionsSortBy.toString()]: (
      state,
      action: ReturnType<typeof setMySubmissionsSortBy>
    ) => ({
      ...state,
      mySubmissionsSortBy: action.payload,
    }),
    [setMySubmissionsIsLoading.toString()]: (
      state,
      action: ReturnType<typeof setMySubmissionsIsLoading>
    ) => ({
      ...state,
      mySubmissionsIsLoading: action.payload,
    }),
  },
  defaultState
);
